import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  QueryList,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { StepperProps, stepperStyles } from '@kite_aerolab/shared/components';
import { StepComponent } from './step.component';
// import { GridComponent } from '../grid/grid.component';

import { getPropByBreakpoint, scrollElement } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-stepper',
  template: `<div [ngClass]="stepper">
    <kite-stack [direction]="orientationValue === 'horizontal' ? 'column' : 'row'" spacing="sm">
      <kite-progress [value]="progress" [orientation]="orientationValue"></kite-progress>
      <kite-grid
        #ref
        class="stepper-grid"
        [cols]="orientationValue === 'horizontal' ? stepsLength : 0"
        [rows]="orientationValue === 'vertical' ? stepsLength : 0"
        spacing="sm"
      >
        <ng-content></ng-content>
      </kite-grid>
    </kite-stack>
  </div>`,
})
export class StepperComponent implements AfterViewInit {
  @ContentChildren(StepComponent) steps: QueryList<StepComponent>;
  @ViewChild('ref', { read: ElementRef }) divRef: ElementRef;
  @Input() css: StepperProps['css'];
  stepsLength: number;
  progress: number;
  orientationValue: StepperProps['orientation'] = 'horizontal';

  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'resize', () => {
      this.setStyle(this.stepNumber);
    });
  }

  /*
   * Paso activo del stepper
   */
  _stepNumber = 1;

  @Input() get stepNumber() {
    return this._stepNumber;
  }

  set stepNumber(value: number) {
    this._stepNumber = value;
    if (value) this.setStyle(value);
  }

  /*
   * Orientación del stepper. El default es horizontal.
   */
  _orientation: StepperProps['orientation'];

  @Input() get orientation() {
    return this._orientation;
  }

  set orientation(value: StepperProps['orientation']) {
    this._orientation = value;
    if (this.stepNumber) this.setStyle(this.stepNumber);
  }

  get stepper(): string[] {
    return [
      stepperStyles({
        orientation: this.orientation,
        css: this.css,
      }).className,
    ];
  }

  setStyle(step: number) {
    if (!isNaN(step) && this.steps) {
      this.stepsLength = this.steps.length;
      this.orientationValue = getPropByBreakpoint(this.orientation);
      const countProgress = (step / this.stepsLength) * 100;
      this.progress = countProgress;
      if (this.steps) {
        this.steps.map((stepNumber, index) => {
          stepNumber.isDisabled = this.stepNumber < index + 1;
        });
      }
    }
  }

  ngAfterViewInit() {
    if (this.divRef && this.divRef.nativeElement) scrollElement(this.divRef.nativeElement);
    if (this.stepNumber) this.setStyle(this.stepNumber);
  }
}
